import { enGB, enUS, es } from 'date-fns/locale';

const getLocaleFromCulture = function getLocaleFromCulture(
  culture: string
): Locale {
  if (culture === 'en-GB') {
    return enGB;
  }
  if (culture === 'es-MX') {
    return es;
  }
  return enUS;
};
export default getLocaleFromCulture;
